<div class="btw-row">
    <div class="btw-col-4">
        <label>API Key</label>
        <btw-text-box
            [(ngModel)]="apiKey" />
    </div>
</div>
<div class="btw-row">
    <div class="btw-col-4">
        <label>Analysis Id</label>
        <btw-text-box
            [(ngModel)]="analysisId" />
    </div>
</div>
<div class="btw-row">
    <div class="btw-col-4">
        <btw-button
            text="Testing"
            (onClick)="handleSubmit()"></btw-button>
    </div>
</div>


<financial-statement-analysis
    [analysisId]="analysisId!" />

<stacked-indicator-analysis
    [analysisId]="analysisId!"
    indicatorName="TopSuppliers"
    description="This indicator shows top 5 suppliers of the company, per month. It can indicate loss of an important supplier or an introduction of a new one." />

<stacked-indicator-analysis
    [analysisId]="analysisId!"
    indicatorName="TopBuyers"
    description="This indicator shows top 5 buyers of the company, per month. It can indicate loss of an important buyer or an introduction of a new one." />

<generic-indicator-analysis
    [analysisId]="analysisId!"
    indicatorName="Salary"
    description="This indicator shows activities related to salary payments. It can indicate an issue with the company liquidity in case the salary 
                 payments are not paid out in regular intervals and\or there is a change in the pattern or size of payouts." />

<generic-indicator-analysis
    [analysisId]="analysisId!"
    indicatorName="IncomeOutcome"
    description="This indicator shows activities related to income and outcome payments. It can indicate issues with company
                 ability to collect payments or changes in the dynamics of inflows and outflows that can hint at an underlying problem with liquidity." />

<generic-indicator-analysis
    [analysisId]="analysisId!"
    indicatorName="TaxesAndContributions"
    description="Taxes and contributions can be paid up to 30 days after the salaries. Increase in duration between salary
                 and taxes payment could indicate that the company is struggling to pay its obligations." />

<generic-indicator-analysis
    [analysisId]="analysisId!"
    indicatorName="InternalTransfer"
    description="This indicator shows internal trasnfers. Increased activity or changes of pattern could indicate that the
                 company struggles to collect funds for paying certain obligations." />

<generic-indicator-analysis
    [analysisId]="analysisId!"
    indicatorName="Loans"
    description="This indicator shows loan payments performed by the company. It can indicate an underyling issue by showing
                 that the company is struggling to pay it's monthly obligations in a consistent manner. It can also indicate amount of debt taken by the company." />

<generic-indicator-analysis
    [analysisId]="analysisId!"
    indicatorName="RoundPayments"
    description="This indicator shows inflows and outflows that are round on last 6 decimasl. With the increase of round
                 outflows the company could have an issue with being able to pay it's obligations." />
